import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ViewNegotiation from '../../ViewNegotiation';

class ViewNegotiationModal extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };
  render() {
    const { className, modalData } = this.props;

    const classList = classNames('view-negotiation-modal', className);
    return <ViewNegotiation className={classList} data={modalData} />;
  }
}

export default ViewNegotiationModal;
